"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.find-index");
var _login = require("../../api/login.js");
var _countryCode = _interopRequireDefault(require("../../countryCode.js"));
var _q = require("q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserControl',
  data: function data() {
    return {
      isDisable: false,
      isFlag: true,
      value: "",
      options: [{
        value: "Y",
        label: "正常"
      }, {
        value: "F",
        label: "冻结"
      }, {
        value: "N",
        label: "已迁移"
      }],
      fileServers: [{
        value: "0",
        label: "中国"
      }, {
        value: "1",
        label: "亚马逊（日本）"
      }, {
        value: "2",
        label: "亚马逊（美国）"
      }, {
        value: "3",
        label: "亚马逊（英国）"
      }, {
        value: "4",
        label: "亚马逊（德国）"
      }, {
        value: "5",
        label: "亚马逊（澳大利亚）"
      }, {
        value: "6",
        label: "亚马逊（新加坡）"
      }, {
        value: "7",
        label: "亚马逊（南非）"
      }],
      sex: "",
      birthday: "",
      personalSign: "",
      hobby: "",
      education: "",
      job: "",
      address: "",
      totalCapacity: "",
      tableData: [],
      officialUserIds: [],
      dialogVisibles: false,
      loading: false,
      isRepeat: false,
      formLabelWidth: "100px",
      form: {
        createTimeEnd: "",
        createTimeStart: "",
        email: "",
        isNormal: "",
        pageNo: 1,
        pageSize: 10,
        telephone: "",
        userName: "",
        fileServer: ''
      },
      phoneFlag: true,
      emailFlag: true,
      multipleSelection: [],
      isNormal: "",
      //修改手机号
      dialogFormVisible: false,
      oldphone: "",
      newphone: "",
      countryCode: "",
      boll: false,
      vCode: "86",
      cities: _countryCode.default,
      newcountry: "86",
      userid: "",
      //修改邮箱
      dialogFormsVisible: false,
      oldemail: "",
      newemail: "",
      total: 0,
      currentPage: 1
    };
  },
  computed: {
    //操作列最小宽度按当前用户可见按钮计算；min-width 语义下列宽会随容器/屏幕自动伸展，窄屏时收缩到该最小值
    opWidth: function opWidth() {
      var _this = this;
      var hasPermit = function hasPermit(url) {
        var permission = _this.$store.state.user.permission || [];
        return permission.findIndex(function (v) {
          return v.attributes.url === url;
        }) !== -1;
      };
      var width = 75; //详情按钮46px + 左右留白，避免过窄
      if (hasPermit("/snuser/official/add") || hasPermit("/snuser/official/remove")) {
        width += 40; //6px间距 + 官方按钮70px
      }
      if (hasPermit("/snuser/admin/add") || hasPermit("/snuser/admin/remove")) {
        width += 40; //6px间距 + 管理员按钮82px
      }
      return width;
    }
  },
  created: function created() {
    this.getList();
  },
  mounted: function mounted() {},
  methods: {
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      setTimeout(function () {
        (0, _login.getUsercontrol)(_this2.form).then(function (res) {
          _this2.tableData = res.voList;
          _this2.total = Number(res.total);
          _this2.loading = false;
          _this2.isRepeat = false;
          _this2.getOfficialList();
        });
      }, 500);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (val == "" || val == null) {
        document.all["changePhone"].style.color = "#000000";
        document.all["changeEmail"].style.color = "#000000";
        this.PhoneFlag = true;
        this.emailFlag = true;
      } else {
        if (val[0].telephone == null) {
          this.PhoneFlag = false;
          document.all["changePhone"].style.color = "#DCDCDC";
        } else {
          this.PhoneFlag = true;
          document.all["changePhone"].style.color = "#000000";
        }
        if (val.length > 0 && val[0].email == null) {
          this.emailFlag = false;
          document.all["changeEmail"].style.color = "#DCDCDC";
        } else {
          this.emailFlag = true;
          document.all["changeEmail"].style.color = "#000000";
        }
      }
    },
    //分页
    changepage: function changepage(currentPage) {
      this.currentPage = currentPage;
      this.form.pageNo = currentPage;
      this.getList();
    },
    // 查找有没有选中数据，没有则返回false
    findSelectData: function findSelectData() {
      if (!this.multipleSelection.length) {
        // 无选中的数据
        return false;
      } else {
        // 有选中的数据
        return true;
      }
    },
    //信息提示框
    msgTip: function msgTip(msgType, msgInfo) {
      this.$message({
        type: msgType,
        message: msgInfo,
        center: true
      });
    },
    //判断云服务器
    type: function type(row) {
      if (row.fileServer == "0") {
        return '中国';
      } else if (row.fileServer == "1") {
        return '亚马逊（日本）';
      } else if (row.fileServer == "2") {
        return '亚马逊（美国）';
      } else if (row.fileServer == "3") {
        return '亚马逊（英国）';
      } else if (row.fileServer == "4") {
        return '亚马逊（德国）';
      } else if (row.fileServer == "5") {
        return '亚马逊（澳大利亚）';
      } else if (row.fileServer == "6") {
        return '亚马逊（新加坡）';
      } else if (row.fileServer == "7") {
        return '亚马逊（南非）';
      }
    },
    //查询
    search: function search() {
      var _this3 = this;
      this.loading = true;
      setTimeout(function () {
        (0, _login.getUsercontrol)({
          createTimeEnd: _this3.form.createTimeEnd,
          createTimeStart: _this3.form.createTimeStart,
          email: _this3.form.email,
          isNormal: _this3.form.isNormal,
          pageNo: 1,
          pageSize: 10,
          telephone: _this3.form.telephone,
          userName: _this3.form.userName,
          fileServer: _this3.form.fileServer
        }).then(function (res) {
          _this3.tableData = res.voList;
          _this3.total = Number(res.total);
          _this3.currentPage = 1;
          _this3.loading = false;
          _this3.getOfficialList();
        });
      }, 500);
    },
    //清空
    empty: function empty() {
      this.form.createTimeEnd = "";
      this.form.createTimeStart = "";
      this.form.telephone = "";
      this.form.isNormal = "";
      this.form.userName = "";
      this.form.email = "";
      this.form.fileServer = "";
      this.getList();
    },
    //弹框关闭
    close: function close() {
      this.dialogFormVisible = false;
      this.dialogFormsVisible = false;
      this.newphone = "";
      this.newemail = "";
    },
    //修改手机号
    changePhone: function changePhone() {
      var _this4 = this;
      if (this.PhoneFlag || this.PhoneFlag == undefined) {
        if (this.multipleSelection.length < 1) {
          this.msgTip("error", "请选择一条数据");
          return;
        } else if (this.multipleSelection.length > 1) {
          this.msgTip("error", "只能选择一条数据");
          return;
        }
        this.multipleSelection.map(function (res) {
          _this4.multipleSelection.map(function (res) {
            _this4.countryCode = res.countryCode;
            _this4.oldphone = res.telephone;
            _this4.userid = res.userId;
          });
          _this4.dialogFormVisible = true;
          _this4.isDisable = false;
        });
      }
    },
    save: function save() {
      var _this5 = this;
      if (this.newphone == "") {
        this.$message({
          type: "warning",
          message: "请填写手机号",
          center: true
        });
      } else {
        if (this.newcountry == "86") {
          if (!/^1\d{10}$/.test(this.newphone)) {
            this.$message({
              type: "warning",
              message: "请填写正确的手机号",
              center: true
            });
          } else {
            this.isRepeat = true;
            this.isDisable = true;
            (0, _login.amendPhone)(this.userid, {
              countryCode: this.newcountry,
              telephone: this.newphone
            }).then(function (res) {
              if (res.success) {
                _this5.$message({
                  type: "success",
                  message: "修改成功",
                  center: true
                });
                _this5.dialogFormVisible = false;
                var tel = _this5.newphone;
                tel = "" + tel;
                var tel1 = tel.substr(0, 3) + "****" + tel.substr(7);
                (0, _login.dataManipulation)(_this5.tableData, _this5.multipleSelection, tel1, "", "");
                //this.getList();
              } else {
                _this5.$message({
                  type: "error",
                  message: res.errorMsg,
                  center: true
                });
                _this5.isRepeat = false;
                _this5.isDisable = false;
              }
            });
          }
        } else {
          if (this.newphone.length < 8 || this.newphone.length > 15) {
            this.$message({
              type: "warning",
              message: "请输入8到15位的手机号",
              center: true
            });
            return;
          }
          if (/^[0-9]*$/.test(this.newphone)) {
            this.isRepeat = true;
            (0, _login.amendPhone)(this.userid, {
              countryCode: this.newcountry,
              telephone: this.newphone
            }).then(function (res) {
              if (res.success) {
                _this5.$message({
                  type: "success",
                  message: "修改成功",
                  center: true
                });
                _this5.dialogFormVisible = false;
                _this5.getList();
              } else {
                _this5.$message({
                  type: "error",
                  message: res.errorMsg,
                  center: true
                });
                _this5.isRepeat = false;
              }
            });
          }
        }
      }
    },
    //修改邮箱
    changeEmail: function changeEmail() {
      var _this6 = this;
      if (this.emailFlag) {
        if (!this.findSelectData()) {
          this.msgTip("error", "至少选择一条数据");
        } else {
          if (this.multipleSelection.length >= 2) {
            this.msgTip("error", "只能选择一条数据");
          } else {
            this.multipleSelection.map(function (res) {
              if (res.email != null) {
                _this6.oldemail = res.email;
                _this6.userid = res.userId;
              }
            });
            this.dialogFormsVisible = true;
            this.isDisable = false;
          }
        }
      }
    },
    keep: function keep() {
      var _this7 = this;
      if (this.newemail == "") {
        this.msgTip("warning", "请填写邮箱号");
      } else {
        if (/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(this.newemail)) {
          this.isRepeat = true;
          this.isDisable = true;
          (0, _login.amendEmail)(this.userid, {
            email: this.newemail
          }).then(function (res) {
            if (res.success) {
              _this7.$message({
                type: "success",
                message: "修改成功",
                center: true
              });
              _this7.dialogFormsVisible = false;
              var tel = _this7.newemail;
              tel = "" + tel;
              var ary = tel.split("");
              ary.splice(1, 2, "**");
              var tel1 = ary.join("");
              (0, _login.dataManipulation)(_this7.tableData, _this7.multipleSelection, "", tel1, "");
              //this.getList();
            } else {
              _this7.$message({
                type: "error",
                message: res.errorMsg,
                center: true
              });
              _this7.isRepeat = false;
              _this7.isDisable = false;
            }
          });
        } else {
          this.msgTip("warning", "请填写正确邮箱号");
        }
      }
    },
    //冻结
    freeze: function freeze() {
      var _this8 = this;
      this.multipleSelection.map(function (res) {
        _this8.userid = res.userId;
        _this8.isNormal = res.isNormal;
      });
      if (!this.findSelectData()) {
        this.msgTip("error", "至少选择一条数据");
      } else {
        if (this.multipleSelection.length >= 2) {
          this.msgTip("error", "只能选择一条数据");
        } else {
          if (this.isNormal == "冻结") {
            this.msgTip("warning", "此条数据已经被冻结！");
          } else {
            if (this.isFlag) {
              this.isFlag = false;
              this.isRepeat = true;
              (0, _login.freezes)({
                flag: "N",
                userId: this.userid
              }).then(function (res) {
                if (res.success) {
                  _this8.$message({
                    type: "success",
                    message: "冻结成功",
                    center: true
                  });
                  (0, _login.dataManipulation)(_this8.tableData, _this8.multipleSelection, "", "", "冻结");
                  _this8.isFlag = true;
                  //this.getList();
                } else {
                  _this8.$message({
                    type: "warning",
                    message: res.errorMsg,
                    center: true
                  });
                  _this8.isRepeat = false;
                  _this8.isFlag = true;
                }
              });
            }
          }
        }
      }
    },
    //解冻
    unfreeze: function unfreeze() {
      var _this9 = this;
      this.multipleSelection.map(function (res) {
        _this9.isNormal = res.isNormal;
        _this9.userid = res.userId;
      });
      if (!this.findSelectData()) {
        this.msgTip("error", "至少选择一条数据");
      } else {
        if (this.multipleSelection.length >= 2) {
          this.msgTip("error", "只能选择一条数据");
        } else {
          if (this.isNormal == "正常") {
            this.msgTip("warning", "请选择需要解冻的数据！");
          } else {
            if (this.isFlag) {
              this.isRepeat = true;
              this.isFlag = false;
              (0, _login.freezes)({
                flag: "Y",
                userId: this.userid
              }).then(function (res) {
                if (res.success) {
                  _this9.$message({
                    type: "success",
                    message: "解冻成功",
                    center: true
                  });
                  (0, _login.dataManipulation)(_this9.tableData, _this9.multipleSelection, "", "", "正常");
                  //this.getList();
                  _this9.isFlag = true;
                } else {
                  _this9.$message({
                    type: "warning",
                    message: res.errorMsg,
                    center: true
                  });
                  _this9.isRepeat = false;
                  _this9.isFlag = true;
                }
              });
            }
          }
        }
      }
    },
    //拉取官方账号列表，存入集合供列表判断（后端返回 { success, voList: [userId...] }，无分页）
    //注意：userId 为超过 JS 安全整数范围（2^53）的大整数，voList 中的 userId 必须以字符串返回，
    //否则 JSON.parse 时精度丢失导致无法与列表行数据匹配（例如 1145221085017862144 会变成 1145221085017862100）
    getOfficialList: function getOfficialList() {
      var _this10 = this;
      (0, _login.officialList)().then(function (res) {
        var list = res && res.voList;
        if (list == null && Array.isArray(res)) {
          list = res;
        }
        if (list != null) {
          //统一转字符串，避免数字/字符串 userId 类型不一致导致匹配失败
          _this10.officialUserIds = list.map(function (item) {
            return (0, _typeof2.default)(item) === "object" && item !== null ? String(item.userId) : String(item);
          });
        }
      }).catch(function () {});
    },
    //判断是否为官方账号（优先使用官方账号集合，集合为空时回退读取行数据字段）
    isOfficialUser: function isOfficialUser(row) {
      if (this.officialUserIds.length > 0) {
        return this.officialUserIds.indexOf(String(row.userId)) !== -1;
      }
      var val = row.isOfficial !== undefined ? row.isOfficial : row.is_official;
      return val === "Y" || val === "1" || val === 1 || val === true;
    },
    //设为官方
    setOfficial: function setOfficial(row) {
      var _this11 = this;
      this.$confirm("确定将用户 " + row.userName + " 设为官方账号？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _login.officialAdd)({
          userId: row.userId
        }).then(function (res) {
          if (res.success) {
            _this11.$message({
              type: "success",
              message: "设置成功",
              center: true
            });
            row.isOfficial = "Y";
            if (_this11.officialUserIds.indexOf(String(row.userId)) === -1) {
              _this11.officialUserIds.push(String(row.userId));
            }
          } else {
            _this11.$message({
              type: "error",
              message: res.errorMsg,
              center: true
            });
          }
        });
      }).catch(function () {});
    },
    //取消官方
    cancelOfficial: function cancelOfficial(row) {
      var _this12 = this;
      this.$confirm("确定将用户 " + row.userName + " 取消官方账号？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _login.officialRemove)({
          userId: row.userId
        }).then(function (res) {
          if (res.success) {
            _this12.$message({
              type: "success",
              message: "取消成功",
              center: true
            });
            row.isOfficial = "N";
            var idx = _this12.officialUserIds.indexOf(String(row.userId));
            if (idx !== -1) {
              _this12.officialUserIds.splice(idx, 1);
            }
          } else {
            _this12.$message({
              type: "error",
              message: res.errorMsg,
              center: true
            });
          }
        });
      }).catch(function () {});
    },
    //判断是否为管理员（user/query/all 返回 isAdmin 字段，兼容 isAdmin / is_admin 及 Y/1/true 取值）
    isAdminUser: function isAdminUser(row) {
      var val = row.isAdmin !== undefined ? row.isAdmin : row.is_admin;
      return val === "Y" || val === "1" || val === 1 || val === true;
    },
    //设置管理员（先调 user-service 真源，成功后同步 resource 副本）
    setAdmin: function setAdmin(row) {
      var _this13 = this;
      this.$confirm("确定将用户 " + row.userName + " 设置为管理员？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _login.adminAdd)({
          userId: row.userId
        }).then(function (res) {
          if (res.success) {
            //真源成功，同步副本；副本成功后才翻转行状态
            _this13.syncAdmin(row, "add");
          } else {
            _this13.$message({
              type: "error",
              message: res.errorMsg,
              center: true
            });
          }
        }).catch(function () {
          _this13.$message({
            type: "error",
            message: "操作失败，请重试",
            center: true
          });
        });
      }).catch(function () {});
    },
    //撤销管理员（先调 user-service 真源，成功后同步 resource 副本）
    cancelAdmin: function cancelAdmin(row) {
      var _this14 = this;
      this.$confirm("确定撤销用户 " + row.userName + " 的管理员权限？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _login.adminRemove)({
          userId: row.userId
        }).then(function (res) {
          if (res.success) {
            //真源成功，同步副本；副本成功后才翻转行状态
            _this14.syncAdmin(row, "remove");
          } else {
            _this14.$message({
              type: "error",
              message: res.errorMsg,
              center: true
            });
          }
        }).catch(function () {
          _this14.$message({
            type: "error",
            message: "操作失败，请重试",
            center: true
          });
        });
      }).catch(function () {});
    },
    //同步管理员副本到 resource-service；副本成功才翻转行状态，副本失败不翻转（按钮保持原样，
    //再次点击即完整重试：user-service 幂等 + resource 副本重试）
    syncAdmin: function syncAdmin(row, action) {
      var _this15 = this;
      var api = action === "add" ? _login.adminAddSync : _login.adminRemoveSync;
      var successMsg = action === "add" ? "设置成功" : "撤销成功";
      api({
        userId: row.userId
      }).then(function (res) {
        if (res.success) {
          row.isAdmin = action === "add" ? "Y" : "N";
          _this15.$message({
            type: "success",
            message: successMsg,
            center: true
          });
        } else {
          _this15.$message({
            type: "warning",
            message: (res.errorMsg || "") + "主操作成功，同步失败，请再次点击重试",
            center: true
          });
        }
      }).catch(function () {
        _this15.$message({
          type: "warning",
          message: "主操作成功，同步失败，请再次点击重试",
          center: true
        });
      });
    },
    //详情
    details: function details(v) {
      var _this16 = this;
      this.dialogVisibles = true;
      (0, _login.getIduser)(v.userId).then(function (res) {
        _this16.sex = res.sex;
        _this16.birthday = res.birthday;
        _this16.personalSign = res.personalSign;
        _this16.hobby = res.hobby;
        _this16.education = res.education;
        _this16.job = res.job;
        _this16.address = res.address;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1;
    },
    handleClick: function handleClick(row) {
      console.log(row);
    }
  }
};